import { trackingConfig } from './constants';
import type { TTrackingConfig } from './types';

export function updateDatadogGlobals(globals: Record<string, unknown>): void {
  window.DD_RUM &&
    window.DD_RUM.onReady(() => {
      for (const key in globals) {
        window.DD_RUM.setViewContextProperty(key, String(globals[key]));
      }
    });
}

export function updateTrackingConfig(config: Partial<TTrackingConfig>): void {
  for (const key in config) {
    (trackingConfig as any)[key] = (config as any)[key];
  }
}

export function getApplicationInfo() {
  return {
    ...getApplicationGlobals(),
    pageLifeDuration: Date.now() - trackingConfig.STARTED_AT,
    pageErrorsTracked: trackingConfig.LOG_ERRORS_TRACKED,
    pageIsFocused: window.document.hasFocus(),
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
  };
}

export function getApplicationGlobals() {
  return {
    appType: trackingConfig.APP_TYPE,
    pageSessionId: trackingConfig.SESSION_ID,
    pageSessionLocale: trackingConfig.USER_LOCALE,
    allowAudioTracksSelector: trackingConfig.ALLOW_AUDIOTRACK_SELECTOR,
    isUserInAudioTrackSelectorTest: trackingConfig.IS_AB_TEST,
    videoId: trackingConfig.VIDEO_ID,
    modalLocation: trackingConfig.MODAL_LOCATION,
  };
}
